export default __webpack_public_path__ + "static/media/ispo-bg@1x.20bbf500.webp";